import { Component } from '@angular/core';

@Component({
  selector: 'uni-main-content',
  templateUrl: './uni-main-content.component.html',
  styleUrls: ['./uni-main-content.component.scss']
})
export class UniMainContentComponent {}
